/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Reminder_Training_HintInputs */

const en_us2_profile_editors_reminder_training_hint = /** @type {(inputs: Profile_Editors_Reminder_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only when a workout is scheduled`)
};

const pt_br2_profile_editors_reminder_training_hint = /** @type {(inputs: Profile_Editors_Reminder_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só quando há treino marcado`)
};

const es_419_profile_editors_reminder_training_hint = /** @type {(inputs: Profile_Editors_Reminder_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo cuando hay un entrenamiento programado`)
};

const pt_pt2_profile_editors_reminder_training_hint = /** @type {(inputs: Profile_Editors_Reminder_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só quando há treino marcado`)
};

const fr_fr2_profile_editors_reminder_training_hint = /** @type {(inputs: Profile_Editors_Reminder_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seulement quand une séance est prévue`)
};

const de_de2_profile_editors_reminder_training_hint = /** @type {(inputs: Profile_Editors_Reminder_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur wenn ein Training geplant ist`)
};

const it_it2_profile_editors_reminder_training_hint = /** @type {(inputs: Profile_Editors_Reminder_Training_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo quando c'è un allenamento in programma`)
};

/**
* | output |
* | --- |
* | "Only when a workout is scheduled" |
*
* @param {Profile_Editors_Reminder_Training_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_reminder_training_hint = /** @type {((inputs?: Profile_Editors_Reminder_Training_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Reminder_Training_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_reminder_training_hint(inputs)
	if (locale === "es-419") return es_419_profile_editors_reminder_training_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_reminder_training_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_reminder_training_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_reminder_training_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_reminder_training_hint(inputs)
	return en_us2_profile_editors_reminder_training_hint(inputs)
});
export { profile_editors_reminder_training_hint as "profile-editors.reminder_training_hint" }